module.exports = __webpack_public_path__ + "img/yzm1.2190ea01.png";